import createIcon from '../../createIcon';

/**
 * @component @name ScatterPlot
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNy4yMDAyIDE3LjIwMDJDOC44NTcwNSAxNy4yMDAyIDEwLjIwMDIgMTUuODU3IDEwLjIwMDIgMTQuMjAwMkMxMC4yMDAyIDEyLjU0MzMgOC44NTcwNSAxMS4yMDAyIDcuMjAwMiAxMS4yMDAyQzUuNTQzMzQgMTEuMjAwMiA0LjIwMDIgMTIuNTQzMyA0LjIwMDIgMTQuMjAwMkM0LjIwMDIgMTUuODU3IDUuNTQzMzQgMTcuMjAwMiA3LjIwMDIgMTcuMjAwMloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMS4yMDAyIDkuMjAwMkMxMi44NTcgOS4yMDAyIDE0LjIwMDIgNy44NTcwNSAxNC4yMDAyIDYuMjAwMkMxNC4yMDAyIDQuNTQzMzQgMTIuODU3IDMuMjAwMiAxMS4yMDAyIDMuMjAwMkM5LjU0MzM0IDMuMjAwMiA4LjIwMDIgNC41NDMzNCA4LjIwMDIgNi4yMDAyQzguMjAwMiA3Ljg1NzA1IDkuNTQzMzQgOS4yMDAyIDExLjIwMDIgOS4yMDAyWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE2LjgwMDIgMjAuODAwMkMxOC40NTcxIDIwLjgwMDIgMTkuODAwMiAxOS40NTcxIDE5LjgwMDIgMTcuODAwMkMxOS44MDAyIDE2LjE0MzMgMTguNDU3MSAxNC44MDAyIDE2LjgwMDIgMTQuODAwMkMxNS4xNDMzIDE0LjgwMDIgMTMuODAwMiAxNi4xNDMzIDEzLjgwMDIgMTcuODAwMkMxMy44MDAyIDE5LjQ1NzEgMTUuMTQzMyAyMC44MDAyIDE2LjgwMDIgMjAuODAwMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ScatterPlot = createIcon('ScatterPlot', [
  [
    'path',
    {
      d: 'M7.2002 17.2002C8.85705 17.2002 10.2002 15.857 10.2002 14.2002C10.2002 12.5433 8.85705 11.2002 7.2002 11.2002C5.54334 11.2002 4.2002 12.5433 4.2002 14.2002C4.2002 15.857 5.54334 17.2002 7.2002 17.2002Z',
      key: '1h0adp',
    },
  ],
  [
    'path',
    {
      d: 'M11.2002 9.2002C12.857 9.2002 14.2002 7.85705 14.2002 6.2002C14.2002 4.54334 12.857 3.2002 11.2002 3.2002C9.54334 3.2002 8.2002 4.54334 8.2002 6.2002C8.2002 7.85705 9.54334 9.2002 11.2002 9.2002Z',
      key: '8qvu71',
    },
  ],
  [
    'path',
    {
      d: 'M16.8002 20.8002C18.4571 20.8002 19.8002 19.4571 19.8002 17.8002C19.8002 16.1433 18.4571 14.8002 16.8002 14.8002C15.1433 14.8002 13.8002 16.1433 13.8002 17.8002C13.8002 19.4571 15.1433 20.8002 16.8002 20.8002Z',
      key: '1l0kh6',
    },
  ],
]);

export default ScatterPlot;
